import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=69b763ee&"
import script from "./CommentList.vue?vue&type=script&lang=js&"
export * from "./CommentList.vue?vue&type=script&lang=js&"
import style0 from "./CommentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommentList.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/gutters/CommentList.vue
// module id = 897
// module chunks = 1